/**
 * O domínio da trilha de acesso (`NR-114`) no front, em pt-BR.
 *
 * O contrato vem em inglês (`AccessRecordResponse`) e é traduzido UMA vez, em
 * `mapeadores.ts`, logo depois do fetch — a tela não conhece o nome do fio.
 */

import type { AccessAction, AccessedResource, ActorType, Role } from '@anery/api-contracts';

import type { Instante } from '../../../shared/dominio/datas';

export type AcaoDeAcesso = AccessAction;
export type RecursoAcessado = AccessedResource;

export interface RegistroDeAcesso {
  readonly id: string;
  readonly ocorridoEm: Instante;
  readonly tipoDeAtor: ActorType;
  readonly usuarioId: string | null;
  /** Fotografia do login no momento do acesso; para máquina, o nome da máquina. */
  readonly login: string;
  readonly papel: Role | null;
  readonly acao: AcaoDeAcesso;
  readonly recurso: RecursoAcessado;
  readonly recursoId: string | null;
  readonly casoId: string | null;
  readonly ticketId: string | null;
  readonly metodo: string;
  /** Template da rota, nunca a URL com query. */
  readonly rota: string;
  readonly status: number;
  readonly ip: string | null;
  readonly correlationId: string;
  readonly duracaoMs: number;
}

export interface PaginaDaTrilha {
  readonly itens: readonly RegistroDeAcesso[];
  readonly total: number;
}

export interface UsuarioDaTrilha {
  readonly id: string;
  readonly login: string;
  readonly nome: string;
}

export const ROTULOS_DE_ACAO: Record<AcaoDeAcesso, string> = {
  Read: 'Leitura',
  Create: 'Criação',
  Update: 'Alteração',
  Delete: 'Exclusão',
};

export const ROTULOS_DE_RECURSO: Record<RecursoAcessado, string> = {
  CaseList: 'Lista de casos',
  CaseDetail: 'Detalhe do caso',
  CaseThread: 'Thread do caso',
  CaseExtractedFields: 'Campos extraídos do caso',
  TriageQueue: 'Fila de triagem',
  TriageDetail: 'Detalhe da triagem',
  OriginalEmail: 'E-mail original',
  Attachment: 'Anexo',
  TriageField: 'Campo da triagem',
  CaptacaoList: 'Esteira de captação',
  EmailInterpretation: 'Leitura do e-mail (interpretador)',
  EmailFailureQueue: 'Fila de falhas de e-mail',
  CaseDocument: 'Documento do caso',
  IwCandidates: 'Candidatos do IW para o paciente',
  IwBudget: 'Orçamento do IW do caso',
};

export const ROTULOS_DE_PAPEL: Record<Role, string> = {
  Operations: 'Operação',
  MedicalAccounts: 'Contas médicas',
  Coordination: 'Coordenação',
};
